import { useDispatch } from 'react-redux';
import { prop } from 'ramda';

import { useUpdateEffect } from '@core/js/hooks/useUpdateEffect';
import { storageService } from '@core/js/services/storage.service';
import { useUserSelector } from '@core/js/store/hooks';

import { setWasLoggedIn } from '@interlayer/js/custom/stores/user/actions';

import { WAS_LOGGED_IN } from './constants';

export const getWasLoggedIn = () => Boolean(storageService.local.getItem(WAS_LOGGED_IN));

export const useSetWasLoggedIn = () => {
    const dispatch = useDispatch();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));

    useUpdateEffect(() => {
        if (!isLoggedIn || getWasLoggedIn()) {
            return;
        }

        dispatch(setWasLoggedIn(true));
        storageService.local.setItem(WAS_LOGGED_IN, true);
    }, [isLoggedIn]);
};
